import { FormGroup, ValidatorFn } from '@angular/forms';

// IVF pregnancies are allowed only from the given gestation week on
export function ivfGestationAgeValidator(minWeek: number): ValidatorFn {
  return (form: FormGroup) => {
    const ivfControl = form.get(
      'currentPregnancyInformation.inVitro.isInVitroFertilized'
    );
    const gestationWeekValue = form.get(
      'currentPregnancyInformation.gestationAge.week'
    ).value;

    if (
      ivfControl.value === true &&
      gestationWeekValue !== null &&
      gestationWeekValue !== '' &&
      Number(gestationWeekValue) < minWeek
    ) {
      ivfControl.setErrors({ ivfGestationAge: true });
      return null;
    }

    if (ivfControl.hasError('ivfGestationAge')) {
      delete ivfControl.errors['ivfGestationAge'];
      ivfControl.updateValueAndValidity();
    }

    return null;
  };
}
